var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileWithoutText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4237 0L22.3729 8.80002V23.32C22.3729 25.021 20.9705 26.4 19.2407 26.4H3.1322C1.40234 26.4 0 25.021 0 23.32V3.08C0 1.37896 1.40234 0 3.1322 0H13.4237Z",
    fill: "#EAEBEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3711 8.80078H16.7124C14.9825 8.80078 13.4219 7.26625 13.4219 5.56522V0.000762939L22.3711 8.80078Z",
    fill: "#537D8A",
    fillOpacity: 0.298039
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWithoutText);
export default __webpack_public_path__ + "static/media/file-without-text.4c4f2b28e74121d3acad4fa3d52c433c.svg";
export { ForwardRef as ReactComponent };